import { themeStyle } from '@repo/ui/theming';

export const defaultTheme = {
  logoColor: themeStyle.varInkMain,
  textColor: themeStyle.varInkBase,
};
